import { render, staticRenderFns } from "./LegendWidgetCell.vue?vue&type=template&id=1a22582a&scoped=true"
import script from "./LegendWidgetCell.vue?vue&type=script&lang=js"
export * from "./LegendWidgetCell.vue?vue&type=script&lang=js"
import style0 from "./LegendWidgetCell.vue?vue&type=style&index=0&id=1a22582a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a22582a",
  null
  
)

export default component.exports